<template>
  <div class="flex items-center justify-center px-4 min-h-[calc(100vh-120px)]">
    <TsSection>
    <TsMedia append-class="flex flex-col items-center text-center max-w-[640px] mx-auto">
      <TsMediaStart append-class="mb-6">
        <TsImage
          data-testid="empty-trolley-image"
          v-if="props && props.image"
          :src="props.image"
          alt="empty-trolley"
          width="304"
          height="169"
          class="inline"
        />
      </TsMediaStart>
      <TsMediaContent>
        <TsTypography
          as="h1"
          data-testid="empty-trolley-heading"
          append-class="mb-0 text-primary leading-[24px]"
          weight="semibold"
          >{{ main_title }}</TsTypography
        >
        <TsTypography
          data-testid="empty-trolley-text"
          append-class="mb-2.5 text-idle-black"
          weight="semibold"
        >
          <template v-if="isAuthenticated">
            {{
              useTranslation(
                "Trolley-checkSavedProductsOrShop",
                "Controleer hieronder uw opgeslagen producten voor latere producten of"
              )
            }}
            <NuxtLinkWithLocale
              to="/"
              class="text-primary underline"
              data-testid="customer-empty-trolley-continue-shop-link"
            >
              {{
                useTranslation("Trolley-continueShopping", "Verder winkelen")
              }}</NuxtLinkWithLocale
            >
          </template>
          <template v-else> {{useTranslation('loginToSeePrevisoulyAdded','Sign in om items te zien die u eerder heeft toegevoegd')}} </template>
        </TsTypography>
        <div v-if="!isAuthenticated" class="flex justify-center flex-wrap gap-2 mt-2 max-[360px]:*:w-full">
          <TsButton
            @click="navigateTo(localePath('/login'))"
            data-testid="guest-empty-trolley-signin-button"
            >{{ useTranslation("signIn", "Sign In") }}</TsButton
          >
          <TsButton
            @click="navigateTo(localePath('/'))"
            outlined
            data-testid="guest-empty-trolley-start-shopping-button"
            >{{useTranslation('startShopping','Begin met winkelen')}}</TsButton
          >
        </div>
      </TsMediaContent>
    </TsMedia>
  </TsSection>
  </div>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";
import { navigateTo } from "#app";

type Props = {
  isAuthenticated?: boolean;
  image?: string;
};

const props = withDefaults(defineProps<Props>(), {
  image: "/images/toolBasket.png",
});

const TsMediaContent = defineAsyncComponent(
  () => import("~/components/organisms/TsMediaContent.vue")
);

const TsMediaStart = defineAsyncComponent(
  () => import("~/components/organisms/TsMediaStart.vue")
);

const localePath = useLocalePath();

const main_title = computed(() =>
  props.isAuthenticated
    ? useTranslation("yourTrolleyIsEmpty", "Uw winkelwagen is leeg")
    : useTranslation("missingCartProducts", "Ontbreken er producten in je winkelwagen?")
);
</script>
